import {
  AiOutlineSortAscending,
  AiOutlineSortDescending,
} from "react-icons/ai";
import { FaSort } from "react-icons/fa";
import SkeletonLoader from "./SkeletonLoader";
import Alert from "./utils/Alert";

const Table = ({
  headers,
  loading,
  handleSort,
  sort,
  renderRow,
  rows = 5,
  cols = 9,
  error = null,
  length,
}) => {
  return (
    <div className="overflow-x-auto border rounded-lg">
      <table className="min-w-full text-xs divide-y divide-gray-200">
        <thead className="min-w-[100%] bg-[#F4FF8E]">
          <tr>
            {headers.map((label, key) => {
              return (
                <th
                  key={key}
                  className={`px-3 py-2 font-medium text-gray-600 uppercase ${
                    label?.sorting === true && "cursor-pointer"
                  }`}
                  onClick={
                    label?.sorting === true
                      ? () => handleSort(label.key)
                      : undefined
                  }
                >
                  <div className="flex text-[10px] items-center gap-[3px]">
                    {label.label}{" "}
                    {sort?.sortField === label.key &&
                      (sort?.sortOrder === "asc" ? (
                        <AiOutlineSortAscending />
                      ) : (
                        <AiOutlineSortDescending />
                      ))}
                    {label?.sorting && sort?.sortField !== label.key && (
                      <FaSort />
                    )}
                  </div>
                </th>
              );
            })}
          </tr>
        </thead>
        {loading ? (
          <SkeletonLoader rows={rows} cols={cols} />
        ) : error ? (
          <td colSpan={cols}>
            <div className="p-2">
              <Alert message={error} type={"error"} />
            </div>
          </td>
        ) : length === 0 ? (
          <td colSpan={cols}>
            <div className="p-2">
              <Alert message={"404 Resource not found."} type={"info"} />
            </div>
          </td>
        ) : (
          renderRow
        )}
      </table>
    </div>
  );
};
export default Table;
